/**
 * IMPORTS
 */
import Store from 'src/store';


/**
 * TYPES
 */
import {IPreferences} from 'src/aggregates/preferences/state.d';


/**
 * CODE
 */

/**
 * I fetch preferences by user id
 *
 * :param userId: the user id to get the preferences
 *
 * :returns: user state
 */
function fetch(userId: number): IPreferences
{
    return Store.getState().preferences.byId[userId];
}


/**
 * I get the color from a given tag.
 *
 * :param tag: tag id
 * :param user: user id
 */
function getTagColor (tag: number, user: number): string | null
{
    // get user preferences
    const preferences = fetch(user);

    // get color from user
    const color = preferences.tagColors[tag];

    // color not found: return null
    if (color === undefined)
    {
        return null;
    }

    // color found: return it
    return color;
}


/**
 * EXPORTS
 */
export {
    fetch,
    getTagColor,
};
